
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.402 8.672l-1.105-1.105L10 11.864 5.703 7.567 4.598 8.672 10 14.074zM18.437 10c0 4.652-3.785 8.437-8.437 8.437-4.652 0-8.437-3.785-8.437-8.437 0-4.652 3.785-8.437 8.437-8.437 4.652 0 8.437 3.785 8.437 8.437zm-1.366 7.071A9.935 9.935 0 0020 10a9.935 9.935 0 00-2.929-7.071A9.935 9.935 0 0010 0a9.935 9.935 0 00-7.071 2.929A9.935 9.935 0 000 10a9.935 9.935 0 002.929 7.071A9.935 9.935 0 0010 20a9.935 9.935 0 007.071-2.929z"}})])
          )
        }
      }
    